import React from "react";
import {
  Form,
  Input
} from "antd";

const { TextArea } = Input;

export function InputTextArea(props) {

  const onFocus = (e) => {
    if (props.isAutoSelect) {
      return e.target.select();
    }
  }

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      rules={[
        {
          required: props.requiredMessage !== null,
          message: props.requiredMessage
        }
      ]}
      style={props.style}
    >
      <TextArea
        allowClear={props.allowClear}
        autoSize={props.autoSize}
        bordered={props.bordered}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onPressEnter={props.onPressEnter}
        onResize={props.onResize}
        cols={props.cols}
        rows={props.rows}
        onFocus={onFocus}
        onChange={props.onChange}
        disabled={props.disabled}
        className={props.className}
        style={props.style}
        defaultValue={props.defaultValue}
      />
    </Form.Item>
  )
}

InputTextArea.defaultProps = {
  requiredMessage: null
};